import { UserPermissions, User } from '@centecomm/portal-service';
import { FeatureApplication } from '../Types/FeatureApplication';
import { FeatureConfiguration } from '../Types/FeatureConfiguration';

const isFeatureApplication = (
    featureApplication: FeatureApplication | undefined,
): featureApplication is FeatureApplication => !!featureApplication && typeof featureApplication !== 'undefined';

const filterApplicationFeatures = (
    featureConfiguration: FeatureConfiguration[],
    checkPermission: (permission: UserPermissions) => boolean,
    currentUser: User,
): FeatureApplication[] =>
    featureConfiguration
        .filter(({ application }: FeatureConfiguration) => {
            if (!application) return false;

            const { permissions = [], isGloballyAccessible = false, isAllowed } = application;

            if (isGloballyAccessible) return true;

            if (permissions && permissions.length > 0) {
                return permissions.some((permission) => checkPermission(permission));
            }

            return !!isAllowed && isAllowed(currentUser);
        })
        .map(({ application }: FeatureConfiguration) => application)
        .filter(isFeatureApplication);

export default filterApplicationFeatures;
